import { render, staticRenderFns } from "./address_edit.vue?vue&type=template&id=bae45e7a&scoped=true&"
import script from "./address_edit.vue?vue&type=script&lang=js&"
export * from "./address_edit.vue?vue&type=script&lang=js&"
import style0 from "./address_edit.vue?vue&type=style&index=0&id=bae45e7a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bae45e7a",
  null
  
)

export default component.exports